export class Paths {
    static Login = '/login';
    static RegisterEuroplan = '/register-europlan';
    static Activate = '/activate/:token';
    static SetPassword = '/password/:token';
    static ResetPassword = '/reset-password';

    static Items = '/items';
    static Workspace = '/workspace';
    static Record = '/record';
    static Extension = '/extension';
    static GenerateApiToken = '/extension/generate-api-token';
    static Settings = '/settings';
    static Settings_Users = '/settings/users';
}
